import { gql } from '@apollo/client';

const DELETE_FOLDER_COLOR_SET = gql`
  mutation DeleteFolderColorSet($siteFolderColorSetId: Int!) {
    deleteFolderColorSet(siteFolderColorSetId: $siteFolderColorSetId)
  }
`;

export default DELETE_FOLDER_COLOR_SET;
